import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  Checkbox,
  Group,
  Modal,
  Rating,
  ScrollAreaAutosize,
  Stack,
  Text,
} from "@mantine/core";
import { useLogger } from "@mantine/hooks";

import { startConfetti } from "@utils/confetti";
import { showInfoNotification } from "@utils/showNotification";

// todo: Add translation - This component is not used so far

interface VideoCallFeedbackProps {
  opened: boolean;
  close: () => void;
}
export const VideoCallFeedbackModal = ({
  opened,
  close,
}: VideoCallFeedbackProps) => {
  const { t } = useTranslation();

  const [rating, setRating] = useState(0);
  // useLogger("rating", [{ rating }]);
  return (
    <Modal
      centered
      title={<Text fw={500}>Video consultation feedback</Text>}
      opened={opened}
      onClose={close}
      scrollAreaComponent={ScrollAreaAutosize}
      styles={{
        body: {
          minHeight: "auto",
        },
      }}>
      <Text lh={1.5} fz={15}>
        How was the overall experience?
      </Text>
      <Rating size={"xl"} mt={"0.5rem"} value={rating} onChange={setRating} />

      {rating > 0 && rating < 5 && (
        <Checkbox.Group
          mt={"1rem"}
          label="What could we improve?"
          styles={{
            label: {
              fontWeight: 400,
              fontSize: 15,
            },
          }}
          // description="This is anonymous"
        >
          <Stack mt="xs" gap={"0.5rem"}>
            <Checkbox
              value="audio"
              label="Audio quality"
              styles={{
                label: {
                  fontWeight: 400,
                },
              }}
            />
            <Checkbox
              value="video"
              label="Video quality"
              styles={{
                label: {
                  fontWeight: 400,
                },
              }}
            />
            <Checkbox
              value="controls"
              label="Call controls (microphone, camera, etc)"
              styles={{
                label: {
                  fontWeight: 400,
                },
              }}
            />
            <Checkbox
              value="connection"
              label="Connection stability"
              styles={{
                label: {
                  fontWeight: 400,
                },
              }}
            />
            <Checkbox
              value="interface"
              label="User interface"
              styles={{
                label: {
                  fontWeight: 400,
                },
              }}
            />
          </Stack>
        </Checkbox.Group>
      )}

      <Group justify="end" mt={"xl"}>
        <Button
          onClick={() => {
            if (rating === 5) {
              startConfetti(50);
            }
            showInfoNotification({ message: "Thank you for your feedback!" });
            setRating(0);
            close();
          }}>
          {t("submit")}
        </Button>
      </Group>
    </Modal>
  );
};
